import React from 'react';

interface DeliveryDetailsIconProps {
  isActive: boolean;
}

export const DeliveryDetailsIcon: React.FC<DeliveryDetailsIconProps> = ({ isActive }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
      <g transform="matrix(1,0,0,-1,0,32)">
        <path
          d="M2,17.5Q1.53125,17.53125,1.5,18L1.5,30Q1.53125,30.4688,2,30.5L7,30.5L7,28Q7,27.5625,7.28125,27.2812Q7.5625,27,8,27L10.5,27L10.5,18Q10.4688,17.53125,10,17.5L2,17.5ZM2,32Q1.15625,31.9688,0.59375,31.4062Q0.03125,30.8438,0,30L0,18Q0.03125,17.15625,0.59375,16.59375Q1.15625,16.03125,2,16L10,16Q10.8438,16.03125,11.4062,16.59375Q11.9688,17.15625,12,18L12,27.1562Q12,28,11.4062,28.5938L8.59375,31.4062Q8,32,7.1875,32L2,32ZM3.75,24Q3.0625,23.9375,3,23.25Q3.0625,22.5625,3.75,22.5L8.25,22.5Q8.9375,22.5625,9,23.25Q8.9375,23.9375,8.25,24L3.75,24ZM3.75,21Q3.0625,20.9375,3,20.25Q3.0625,19.5625,3.75,19.5L8.25,19.5Q8.9375,19.5625,9,20.25Q8.9375,20.9375,8.25,21L3.75,21Z"
          fill={isActive ? '#223db6' : '#000000de'}
        />
      </g>
    </svg>
  );
};

export default DeliveryDetailsIcon;
